import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/ui-kit/templates/EmptyState/EmptyState';

export function CreateUserEmptyComponent() {
  const { t } = useTranslation();

  return (
    <EmptyState
      title={t('pages.dashboard.createUser.form.rules.notFound')}
      state={t('pages.dashboard.search.noResult')}
      icon="search_v1"
    />
  );
}
